module.exports = __webpack_public_path__ + "static/media/law_in_hand_3.cc123379.jpg";